import React from 'react';
import { useNavigate } from 'react-router-dom';
import CoverPlate from './CoverPlate';
import Icon from './Icon';
import { fmtViews, fmtDuration } from '../../utils/format';

export default function EditorRow({ video, rank, onClick }) {
    const navigate = useNavigate();

    return (
        <a
            href={`/watch/${video.id}`}
            onClick={(e) => { e.preventDefault(); onClick ? onClick() : navigate(`/watch/${video.id}`); }}
            style={{
                display: 'flex', alignItems: 'center', gap: 12,
                padding: 8, background: 'transparent',
                border: '1px solid #18181B', borderRadius: 12,
                cursor: 'pointer', textDecoration: 'none', color: 'inherit', width: '100%',
            }}
        >
            <div style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 22, fontWeight: 700,
                color: rank <= 3 ? '#e60073' : '#3F3F46',
                width: 32, textAlign: 'center', flexShrink: 0,
            }}>
                {String(rank).padStart(2, '0')}
            </div>
            <div style={{ width: 52, flexShrink: 0 }}>
                <CoverPlate video={video} ratio="2/3" size="sm" radius={8} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                    fontSize: 13, fontWeight: 600, color: '#fff', lineHeight: 1.25,
                    display: '-webkit-box', WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical', overflow: 'hidden',
                }}>
                    {video.title}
                </div>
                <div style={{
                    marginTop: 4, display: 'flex', alignItems: 'center', gap: 6,
                    fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: '#71717A',
                }}>
                    <Icon name="eye" size={12} color="#71717A" stroke={1.5} />
                    <span>{fmtViews(video.views)}</span>
                    <span style={{ width: 2, height: 2, borderRadius: 2, background: '#3F3F46', display: 'inline-block' }} />
                    <span>{fmtDuration(video.duration)}</span>
                </div>
            </div>
            <Icon name="chevron-right" size={16} color="#52525B" stroke={2} />
        </a>
    );
}
